import intlTelInput from 'intl-tel-input';
import IMask from 'imask';

class Validation {
	constructor() {
		this.init();
	}

	init() {
		this.phoneValidation();
	}

	phoneValidation(rawNumber = null) {
		const getInputMask = (input) => input.placeholder.replace(/[0-9]/g, '0');

		const initInputTelMask = (input) => {
			const inputMask = getInputMask(input);
			input.mask = IMask(input, { mask: inputMask });
		};

		const updateInputTelMask = (input) => {
			const inputMask = getInputMask(input);

			// Удаляем старую маску, если она была
			if (input.mask) {
				input.mask.destroy();
			}

			// Создаем новую маску
			input.mask = IMask(input, { mask: inputMask });
		};

		const phones = document.querySelectorAll('[data-input="tel"] input');

		phones.forEach((phone) => {
			// Инициализация intl-tel-input, если не была ранее инициализирована
			if (!phone.iti) {
				const iti = intlTelInput(phone, {
					initialCountry: 'ru',
					onlyCountries: [
						'ru',
						'am',
						'by',
						'kg',
						'uz',
						'kz',
						'tj',
						'ge',
						'ee',
						'lv',
						'lt',
						'it',
						'es',
						'fr',
						'th',
						'id',
						'cn',
						'mn',
						'il',
						'qa',
						'ae',
						'az',
						'bg',
						'be',
						'hu',
						'de',
						'gr',
						'dk',
						'cy',
						'nl',
						'no',
						'pl',
						'pt',
						'md',
						'ro',
						'rs',
						'sk',
						'si',
						'fi',
						'hr',
						'me',
						'cz',
						'ch',
						'se',
					],
					countrySearch: false,
					separateDialCode: true,
					loadUtils: () => import('intl-tel-input/utils'),
					customPlaceholder: (selectedCountryPlaceholder) =>
						selectedCountryPlaceholder,
				});
				phone.iti = iti;

				// Ждем, пока Promise разрешится, чтобы инициализировать маску
				phone.iti.promise.then(() => {
					initInputTelMask(phone);

					// Устанавливаем country-code
					phone.setAttribute(
						'data-country-code',
						`+${iti.getSelectedCountryData().dialCode}`,
					);

					// Обработчик смены страны
					phone.addEventListener('countrychange', () => {
						phone.setAttribute(
							'data-country-code',
							`+${iti.getSelectedCountryData().dialCode}`,
						);

						if (phone.mask) {
							updateInputTelMask(phone);
							setTimeout(() => {
								updateInputTelMask(phone);
							}, 0);
						}
					});
				});
			}

			// При получении номера с бэка
			if (rawNumber) {
				const numberStr = rawNumber.toString();
				const cleanNumber = numberStr.replace(/\D/g, ''); // Убираем все нецифровые символы
				const numberWithPlus = cleanNumber.startsWith('+')
					? cleanNumber
					: `+${cleanNumber}`;

				// Ждем, пока promise разрешится, чтобы безопасно использовать utils.formatNumber
				phone.iti.promise.then(() => {
					try {
						// Устанавливаем номер телефона в поле
						phone.value = numberWithPlus;

						// Обновляем номер через intl-tel-input
						phone.iti.setNumber(numberWithPlus);

						// Если нужно, можно вызвать utils для форматирования номера
						const selectedCountryData = phone.iti.getSelectedCountryData();
						if (selectedCountryData && phone.iti.utils) {
							const nationalNumber = phone.iti.utils.formatNumber(
								cleanNumber,
								selectedCountryData.iso2,
								0,
							);
							phone.value = nationalNumber;
						}

						// Обновляем country-code
						phone.setAttribute(
							'data-country-code',
							`+${phone.iti.getSelectedCountryData().dialCode}`,
						);

						// Обновляем маску
						if (phone.mask) {
							updateInputTelMask(phone);
						}
					} catch (e) {
						console.error('Error setting phone number:', e);
					}
				});
			}
		});
	}
}

export default new Validation();
